'use client';

import { TUT_LEVEL_COLORS } from '@/components/tut-list/tut-constants';
import { TUT_LECTURE_MAP } from '@/components/tut-list/tut-lectures';
import TutorCard from '@/components/tut-list/TutCard';
import { Box, Container, Grid, Typography } from '@mui/material';
import { Center } from '@ocodelib/mui';
import { PageBanner } from '@repo-ui/components/PageBanner';
import { routerPushI18n } from '@repo-ui/router';
import { useMemo } from 'react';

const BANNER_TINT = '#80DEEA';
const BANNER_BACKGROUND = '#121212';

const BANNER_TABS = [
  { key: '/tutor/intro', label: '튜터란' },
  { key: '/tutor/blox/list', label: '블록코딩' },
  { key: '/tutor/py/list', label: '파이썬' },
  { key: '/tutor/js/list', label: '자바스크립트' },
  { key: '/tutor/p5/list', label: 'P5' },
] as const;

export function BloxTutorListFeature() {
  const { basic, beginning, intermediate = [], advanced = [] } = TUT_LECTURE_MAP;
  const basicAndBegining = useMemo(() => basic.concat(beginning), [basic, beginning]);

  return (
    <Box className="BloxTutorListFeature-root" sx={{ pb: 8 }}>
      <PageBanner
        title="튜터"
        tint={BANNER_TINT}
        background={BANNER_BACKGROUND}
        contrastColor="#222"
        bgImgSrc="/_static/images/page-banner/top_banner4.png"
        tabKey="/tutor/blox/list"
        tabs={BANNER_TABS}
        breadcrumbProps={{
          tint: '#fff',
          section: '코딩',
          currentTitle: '튜터',
        }}
        onChangeTab={(_, value) => {
          routerPushI18n(value);
        }}
      />
      <Container maxWidth="lg">
        <Box sx={{ mt: '60px', mb: 2 }}>
          {/* <SectionHeader sx={{ bgcolor: TUT_LEVEL_COLORS['beginning'].primary, color: '#fff' }}>
            기초 및 초급 강좌
          </SectionHeader> */}
          <Typography
            sx={{
              ml: 1,
              fontSize: '1.4rem',
              fontWeight: 800,
              color: TUT_LEVEL_COLORS['beginning'].primary,
            }}
          >
            기초 및 초급 강좌
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {basicAndBegining.map((tut) => (
            <Grid key={tut.tutId} size={{ xs: 12, sm: 6, md: 4 }}>
              <TutorCard tutor={tut} />
            </Grid>
          ))}
        </Grid>

        {intermediate.length > 0 && (
          <>
            <Box sx={{ mt: 6, mb: 2 }}>
              {/* <SectionHeader
                sx={{ bgcolor: TUT_LEVEL_COLORS['intermediate'].primary, color: '#fff' }}
              >
                중급 강좌
              </SectionHeader> */}
              <Typography
                sx={{
                  ml: 1,
                  fontSize: '1.4rem',
                  fontWeight: 800,
                  color: TUT_LEVEL_COLORS['intermediate'].primary,
                }}
              >
                중급 강좌
              </Typography>
            </Box>
            <Grid container spacing={2}>
              {intermediate.map((tut) => (
                <Grid key={tut.tutId} size={{ xs: 12, sm: 6, md: 4 }}>
                  <TutorCard tutor={tut} />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        {advanced.length > 0 && (
          <>
            <Box sx={{ mt: 6, mb: 2 }}>
              {/* <SectionHeader sx={{ bgcolor: TUT_LEVEL_COLORS['advanced'].primary, color: '#fff' }}>
                고급 강좌
              </SectionHeader> */}
              <Typography
                sx={{
                  ml: 1,
                  fontSize: '1.4rem',
                  fontWeight: 800,
                  color: TUT_LEVEL_COLORS['advanced'].primary,
                }}
              >
                고급 강좌
              </Typography>
            </Box>
            <Grid container spacing={2}>
              {advanced.map((tut) => (
                <Grid key={tut.tutId} size={{ xs: 12, sm: 6, md: 4 }}>
                  <TutorCard tutor={tut} />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        <Center
          sx={{
            mt: 10,
            color: '#aaa',
            // width: '100%',
            // bgcolor: '#8cacff',
            // borderRadius: 1,
          }}
        />
      </Container>
    </Box>
  );
}
